import { deepFind, deepFilter } from 'react-children-utilities'
const Header = () => null
const Icon = () => null
const Subheader = () => null
const Body = () => null
const Footer = () => null
const Close = () => null
const FooterLeft = () => null
const FooterRight = () => null
const Subtitle = () => null
const Title = () => null

const First = () => null
const Second = () => null
const Third = () => null

const Col = () => null

const CardCopyContributor = ({ children, type, ...rest }) => {

	const header = deepFind(children, child => child.type === Header)
	const subheader = deepFind(children, child => child.type === Subheader)
	const cardBody = deepFind(children, child => child.type === Body)
	const cardFooter = deepFind(children, child => child.type === Footer)
	const close = deepFind(children, child => child.type === Close)
	const footerLeft = deepFind(children, child => child.type === FooterLeft)
	const footerRight = deepFind(children, child => child.type === FooterRight)
	const cardSubtitle = deepFind(children, child => child.type === Subtitle)
	const cardTitle = deepFind(children, child => child.type === Title)


	const cols = deepFilter(cardBody?.props.children, child => {
		return child
	})


	return (
		<div className="card-contributor" {...rest}>

			{header && (
				<div className={type === "data-dictionary" ? "card-contributor-data__dictionary__header" : "card-contributor__header"}>
					<div className="card-contributor__header__left">
						<div className="card-contributor__title">
							<div className="card-contributor__title__left">

							</div>
							<div className="card-contributor__title__right">
								<div className="card-contributor__title__right__top">
									{cardTitle && cardTitle.props.children}
								</div>
								<div className="card-contributor__title__right__bottom">
									{cardSubtitle && cardSubtitle.props.children}
								</div>
							</div>
						</div>
					</div>
					<div className="card-contributor__header__right">
						{close &&
							<div className="card-contributor__close" {...close.props}>
								{close.props.children}
							</div>
						}
					</div>
				</div>
			)}
			<hr/>
			{subheader && (
				<div className="card-contributor__sub-header">
					{subheader && subheader.props.children}
				</div>
			)}

			{cardBody && (
				<div className="card-contributor__content">
					<div className="card-contributor__content__cols">
						{cols && cols.map((col, index) => {
							return (
								<div className={type === "data-dictionary" ? "card-contributor__content__data-col" : "card-contributor__content__col"} key={index}>{col.props.children}</div>
							)
						})}
					</div>
				</div>
			)}

			{cardFooter && (
				<div className="card-contributor__footer">
					<div className="card-contributor__footer__left">
						{footerLeft && footerLeft.props.children}
					</div>
					<div className="card-contributor__footer__right">
						{footerRight && footerRight.props.children}
					</div>
				</div>
			)}


		</div>
	)
}

CardCopyContributor.Header = Header
CardCopyContributor.Header.Icon = Icon
CardCopyContributor.Header.Title = Title
CardCopyContributor.Header.Subtitle = Subtitle
CardCopyContributor.Header.Close = Close
CardCopyContributor.Subheader = Subheader
CardCopyContributor.Body = Body
CardCopyContributor.Body.First = First
CardCopyContributor.Body.Second = Second
CardCopyContributor.Body.Third = Third
CardCopyContributor.Footer = Footer
CardCopyContributor.Footer.Left = FooterLeft
CardCopyContributor.Footer.Right = FooterRight
CardCopyContributor.Body.Col = Col

export default CardCopyContributor
